// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/conti-analitici?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, codice, descrizione, natura, attivo, figli }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse?societaId=',
    requestBody: null,
    response: '{ commesse: [{ id, numero, descrizione }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/divisioni-analitiche?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, codice, descrizione, attivo }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/movimenti-conto-analitico?societaId=&dataDal=&dataAl=&natura=&contoAnaliticoId=&divisioneId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, contoCodice, contoDescrizione, natura, data, importo, competenzaDal, competenzaAl, descrizione, numeroDocumento, commessaNumero, origine }] }'
  },
  {
    method: 'PUT',
    endpoint: '/api/movimenti-conto-analitico/:id',
    requestBody: '{ contoAnaliticoId, data, importo, competenzaDal, competenzaAl, descrizione, numeroDocumento, commessaId }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'POST',
    endpoint: '/api/movimenti-conto-analitico',
    requestBody: '{ societaId, contoAnaliticoId, data, importo, competenzaDal, competenzaAl, descrizione, numeroDocumento, commessaId }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/movimenti-conto-analitico/:id',
    requestBody: null,
    response: '{ success: true }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
